// PROD-9606 F6: the query a Care pricing link carries (VD-15). No param means the default Consistency + Recording page.

export type PricingLinkChoice = 'default' | 'legacy' | 'consistency_plans';

export const PRICING_LINK_OPTIONS: { value: PricingLinkChoice; label: string }[] = [
  { value: 'default', label: 'Default (Consistency + Recording plans)' },
  { value: 'legacy', label: 'Legacy plans' },
  { value: 'consistency_plans', label: 'Consistency plans' }
];

export interface PricingLinkInput {
  currency?: string | null; // country code; absent on a magic link, whose redirect is relative
  sessionsPerWeek?: string | number | null; // '' means none chosen; 0 is a real choice
  pricing?: PricingLinkChoice | string | null;
}

export function buildPricingLinkParams(input: PricingLinkInput): Record<string, string> {
  const params: Record<string, string> = {};
  if (input.currency) params.country_code = input.currency;
  if (
    input.sessionsPerWeek !== '' &&
    input.sessionsPerWeek !== null &&
    input.sessionsPerWeek !== undefined
  ) {
    params.s_per_week = String(input.sessionsPerWeek);
  }
  if (input.pricing === 'legacy' || input.pricing === 'consistency_plans')
    params.pricing = input.pricing;
  return params;
}

export function buildPricingQuery(input: PricingLinkInput): string {
  return new URLSearchParams(buildPricingLinkParams(input)).toString();
}
